export default __webpack_public_path__ + "static/media/Insurance-Proposal-Form 2024.618ee250.pdf";